export default "__VITE_ASSET__DZl8CSWH__"